<template lang="html">
  <ext-form
    :formData="formData"
    :submitProxy="submitProxy"
    :loadProxy = "loadProxy"
    :extraData = "extraData"
  >
    <b-form-fieldset
      label="Название"
      :feedback = "errors.first('name')"
      :class="{'is-invalid': errors.has('name') }"
    >
      <input class="form-control" v-validate="'required'" v-model="formData.name" name="name"/>
    </b-form-fieldset>
    <b-form-fieldset
      label="Стоимость"
      :feedback = "errors.first('cost')"
      :class="{'is-invalid': errors.has('cost') }"
    >
      <input class="form-control" v-validate="'numeric'" v-model="formData.cost" name="cost"/>
    </b-form-fieldset>

  </ext-form>
</template>

<script>
import ExtForm from '@/components/ExtForm'

export default {
  components: {
    ExtForm
  },
  props: ['loadProxy', 'submitProxy', 'extraData'],
  data () {
    return {
      formData: {
        name: '',
        cost: ''
      }
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// CourseForm.vue?28d299cb